import { findWhere } from "underscore";
import { Field } from "../../../../types/TenantInterfaces";
import { useMemo } from "react";

export default function useGroupBySchema(fields?: Field[], groupBy?: string) {
  const groupByFieldSchema = useMemo(() => {
    if (!groupBy || !fields) return;

    return findWhere(fields, { APIName: groupBy });
  }, [fields, groupBy]);

  return groupByFieldSchema;
}
